import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export interface DraggableItem {
  id: string;
  index: number;
  type: string;
}

export interface DragResult {
  isDragging: boolean;
  setNodeRef: (node: HTMLElement | null) => void;
  setActivatorNodeRef: (node: HTMLElement | null) => void;
  style: React.CSSProperties;
  attributes: Record<string, any>;
  listeners: Record<string, any> | undefined;
}

export interface DraggableOptions {
  direction?: 'vertical' | 'horizontal';
  dragDisabled?: boolean;
}

export function useDraggable(
  id: string,
  options: DraggableOptions = {},
): DragResult {
  const { dragDisabled = false } = options;

  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    disabled: dragDisabled,
  });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return {
    isDragging,
    setNodeRef,
    setActivatorNodeRef,
    style,
    attributes,
    listeners: dragDisabled ? undefined : listeners,
  };
}
